import script from "./LocationBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationBlock.vue?vue&type=script&setup=true&lang=ts"

import "./LocationBlock.vue?vue&type=style&index=0&id=efd3b0ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd3b0ac"]])

export default __exports__